export const ButtonThemes = {
  Primary: 'primary',
  Secondary: 'secondary',
  Outlined: 'outlined',
  // @deprecated используй Link вместо Ghost
  Ghost: 'ghost',
  Link: 'link',
} as const;

export type ButtonThemes = (typeof ButtonThemes)[keyof typeof ButtonThemes];

export const ButtonSizes = {
  Small: 's',
  Medium: 'm',
  Large: 'l',
} as const;

export type ButtonSizes = (typeof ButtonSizes)[keyof typeof ButtonSizes];
